export const FB_PIXEL_ID = process.env.NEXT_PUBLIC_FACEBOOK_PIXEL_ID;

export const pageview = () => {
  if(!window.fbq) {
    console.log('Facebook Pixel not initialized');
    return;
  }

  window.fbq('track', 'PageView');
};

// https://developers.facebook.com/docs/facebook-pixel/advanced/
export const event = (name: string, options: Record<string, any> = {}) => {
  if(!window.fbq) {
    console.log('Facebook Pixel not initialized');
    return;
  }
  
  window.fbq('track', name, options);
};
